import React, { useState, useEffect } from "react";
import { api } from "../../components/Api/api";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { Table, Button, Switch, message, Popconfirm, Space, Image } from "antd";
import { EyeFilled, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useAuth } from "../../components/Auth";
import ModalEditUserContact from "./ModalEditUserContact";

// const host = 'https://cdn.anvui.vn/';

function UserContactList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [switchLoading, setSwitchLoading] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await api.get("api/v1/web-user-contact", {
        params: {
          current,
          pageSize,
          sort: "created_at.desc",
        },
      });
      const procData = res.data.data.map((item, index) => ({
        ...item,
        stt: index + 1,
        key: index,
      }));
      setTotal(res.data.total);
      setData(procData);
    } catch (err) {
      console.log(err);
      if (err === 401) {
        auth.signOut(() => navigate("/login"));
      } else {
        navigate("/error");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [current, pageSize]);

  const handleEdit = (record) => {
    setSelectedRecord(record);
    setModalVisible(true);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
    setSelectedRecord(null);
  };

  const handleModalSuccess = () => {
    fetchData();
  };

  const handleDelete = async (record) => {
    setLoading(true);
    await api
      .delete("api/v1/web-user-contact/" + record.id)
      .then((res) => {
        fetchData();
        message.success("Successfully deleted.");
      })
      .catch((err) => navigate("/error"));
  };

  // Define the table columns...
  const columns = [
    {
      title: "Stt",
      dataIndex: "stt",
      key: "stt",
      width: 50,
      render: (stt) => {
        return stt ? <div>{stt + (current - 1) * pageSize}</div> : <div></div>;
      },
    },
    {
      title: "Họ tên",
      dataIndex: "fullName",
      key: "fullName",
      width: 125,
      render: (fullName, record) => {
        return fullName ? <div>{fullName}</div> : <div></div>;
      },
    },
    {
      title: "Số điện thoại",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: 125,
    },
    { title: "Email", dataIndex: "email", key: "email", width: 125 },
    { title: "Địa chỉ", dataIndex: "address", key: "address", width: 125 },
    { title: "Tiêu đề", dataIndex: "subject", key: "subject", width: 125 },
    { title: "Nội dung", dataIndex: "message", key: "message", width: 300 },
    {
      title: "Ngày tạo",
      dataIndex: "created_at",
      key: "created_at",
      width: 125,
      render: (created_at) => {
        return created_at ? (
          <div>{new Date(created_at).toLocaleString()}</div>
        ) : (
          <div></div>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            style={{ backgroundColor: "orange" }}
            size="small"
            icon={<EyeFilled />}
            onClick={() => console.log("View")}
          />
          <Button
            type="primary"
            ghost
            size="small"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          />
          <Popconfirm
            title="Bạn chắc chắn muốn xóa tin này?"
            okText="Yes"
            cancelText="No"
            placement="topRight"
            onConfirm={() => handleDelete(record)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
      width: 75,
    },
  ];

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <Table
            dataSource={data}
            columns={columns}
            pagination={{
              pageSize: pageSize,
              current: current,
              total: total,
              showQuickJumper: true,
              showTotal: (total, range) =>
                `Showing ${range[0]} to ${range[1]} of ${total} entries`,
              onChange: (page, pageSize) => {
                setCurrent(page);
                setPageSize(pageSize);
              },
            }}
            bordered
            size="middle"
            style={{ margin: "10px 0px" }}
          />
          <ModalEditUserContact
            visible={modalVisible}
            onCancel={handleModalCancel}
            record={selectedRecord}
            onSuccess={handleModalSuccess}
          />
        </div>
      )}
    </div>
  );
}

export default UserContactList;
